/*
 * @Author: Vanny
 * @Date: 2019-09-05 16:00:16
 * @LastEditors: Vanny
 * @LastEditTime: 2020-05-27 17:23:55
 * @Description: 报表相关API(Java)
 */
import axios from 'axios';
import invariant from 'invariant';

import { isProdTest } from '../utils';
import { deepConvertCamel } from '../tools';

// 获取报表配置项
export function requestReportConfig(params) {
  invariant(params.reportKey, '请求报表配置，缺少 key 值');

  return axios.post('/j/service-report-v2/report/getConfig', deepConvertCamel(params, true), {
    headers: { 'Content-Type': 'application/json' },
    axiosConfig: { key: 'native', env: isProdTest() ? 'test' : '' },
  });
}
export function requestReportList(params) {
  invariant(params.reportKey, '请求报表配置，缺少 key 值');

  return axios.post('/j/service-report-v2/report/query/forMap', deepConvertCamel(params, true), {
    headers: { 'Content-Type': 'application/json' },
    axiosConfig: { key: 'native', env: isProdTest() ? 'test' : '' },
  });
}

export function requestExportList(params) {
  invariant(params.reportKey, '请求报表配置，缺少 key 值');
  return axios.post('/j/service-report-v2/report/export', deepConvertCamel(params, true), {
    headers: { 'Content-Type': 'application/json' },
    axiosConfig: { key: 'native', env: isProdTest() ? 'test' : '' },
  });
}
